// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptInFlagDisplayHelpText{box-sizing:border-box;cursor:auto;display:inline;font:12px/1.4em "UbuntuRegular",Arial,Helvetica,sans-serif;margin-left:3px}.OptInFlagDisplayHelpText .thumbnail_flag{margin:0px 2px;padding-left:0px}.OptInFlagDisplayHelpText .thumbnail_flag .fi{display:inline-flex}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
